import React, { useState } from 'react';
// import { createBrowserRouter, RouterProvider, Route, Outlet } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import StoryForm from './components/StoryForm';
import StoriesList from './components/StoriesList';
import Admin from './components/admin/Admin';
import { Analytics } from "@vercel/analytics/react"

const appTranslations = {
  en: {
    submitStory: 'Submit Story',
    viewStories: 'View Stories',
    selectLanguage: 'Select Language',
    english: 'English',
    sinhala: 'සිංහල',
    tamil: 'தமிழ்'
  },
  si: {
    submitStory: 'කතාව ඉදිරිපත් කරන්න',
    viewStories: 'කතා බලන්න',
    selectLanguage: 'Select Language',
    english: 'English',
    sinhala: 'සිංහල',
    tamil: 'தமிழ்'
  },
  ta: {
    submitStory: 'கதையை சமர்ப்பிக்கவும்',
    viewStories: 'கதைகளைப் பார்க்கவும்',
    selectLanguage: 'Select Language',
    english: 'English',
    sinhala: 'සිංහල',
    tamil: 'தமிழ்'
  }
};

const App = () => {
  const [language, setLanguage] = useState('si');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Define routes using the new createBrowserRouter API
  // const router = createBrowserRouter([...]); 

  return (
    <Router>
    <AppContainer>
      <MainContent>
        <Routes>
          <Route path="/" element={
            <StoryForm 
              language={language} 
              setLanguage={setLanguage} 
              translations={appTranslations[language]} 
              isDropdownOpen={isDropdownOpen} 
              setIsDropdownOpen={setIsDropdownOpen} 
            />
          } />
          <Route path="/stories" element={<StoriesList language={language} translations={appTranslations[language]} />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Analytics />
      </MainContent>
    </AppContainer>
  </Router>
    // <AppContainer>
    //   <MainContent>
    //     <RouterProvider router={router} />
    //   </MainContent>
    // </AppContainer>
  );
};

const AppContainer = styled.div`
  min-height: 100vh;
  position: relative;
`;

const MainContent = styled.main`
  width: 100%;
  height: 100vh;
  position: relative;
  z-index: 1;
`;

export default App;
